var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntervencionesespecficas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 858.74 858.74",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.94,270.43h-186.6V68.8c0-37.93-30.87-68.8-68.8-68.8h-195.31c-37.94,0-68.8,30.87-68.8,68.8v201.63H68.8c-37.93,0-68.8,30.86-68.8,68.8v195.31c0,37.93,30.87,68.8,68.8,68.8h201.63v186.6c0,37.93,30.86,68.8,68.8,68.8h195.31c37.93,0,68.8-30.87,68.8-68.8v-186.6h186.6c37.93,0,68.8-30.87,68.8-68.8v-195.31c0-37.94-30.87-68.8-68.8-68.8ZM525.83,564.58v216.65h-177.89v-216.65c0-21.37-17.39-38.75-38.76-38.75H77.51v-177.89h231.67c21.37,0,38.76-17.39,38.76-38.76V77.51h177.89v231.67c0,21.37,17.38,38.76,38.75,38.76h216.65v177.89h-216.65c-21.37,0-38.75,17.38-38.75,38.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntervencionesespecficas);
export default __webpack_public_path__ + "static/media/Intervenciones específicas.75fa0882c93a2654b00467bde5f95c42.svg";
export { ForwardRef as ReactComponent };